<template>
  <div id="mc6">
    <div class="backdrop">
      <div class="img-container">
        <img src="../../assets/bg-mc6.png" :style="setPos" alt="" />
      </div>
    </div>
    <comp-header
      :leftIcon="headerLeftIcon"
      :rightIcon="headerRightIcon"
      :rightSubIcon="headerRightSubIcon"
      :headerPosition="headerPos"
      :pageTitle="headerPageTitle"
      :rightSubBadge="unreadNotiFlag"
      :leftClick="showMenu"
      :rightClick="share"
      :rightSubClick="showNotification"
    />
    <comp-bottom-tab :tabActive="tab"></comp-bottom-tab>
    <comp-share
      v-if="showModal"
      @fbShare="fbShare"
      @urlShare="urlShare"
      @close="showModal = false"
    >
      <p slot="header" v-html="$t('friends.share')"></p>
    </comp-share>
    <div class="mc6-wrapper">
      <div class="mc6-container">
        <div class="intro-txt" v-if="info" v-html="infoText"></div>
        <div class="user-wrapper">
          <div
            v-for="(item, index) in friends"
            :class="['user-container', item.position]"
            @click="item.click"
            v-bind:key="index"
          >
            <comp-profile
              :userInitial="item.nickname.split('')[0]"
              :profileImage="item.photoUrl"
            />
            <span>{{ item.typeName }}</span>
          </div>
          <div class="user-container center" @click="checkCntBeforeGo('/role')">
            <comp-profile :userInitial="`나`" :profileImage="myProfileImage" />
            <span>{{ myType }}</span>
          </div>
        </div>
      </div>
    </div>
    <comp-modal v-if="copyModal" @confirm="copyModal = !copyModal">
      <p slot="body" v-html="copyModalMsg"></p>
    </comp-modal>
    <comp-modal
      v-if="goTestModal"
      @cancel="goTestModal = !goTestModal"
      @confirm="goTest"
      buttonTwo
      titleShow
    >
      <h3 slot="header">{{ $t("myMenu.modalHeader") }}</h3>
      <p slot="body" v-html="$t('myMenu.modalBody')"></p>
    </comp-modal>
    <comp-modal v-if="friendsModal" @confirm="addFriendsDone">
      <p slot="body">{{ friendsModalBody }}</p>
    </comp-modal>
    <comp-loading v-if="isLoading"></comp-loading>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */

import common from '@/utils/common';
import CompHeader from '@/components/CompHeader';
import CompProfile from '@/components/CompProfile';
import CompBottomTab from '@/components/CompBottomTab';
import CompShare from '@/components/CompShare';
import RESPONSE from '@/constants/response';
import TEST from '@/constants/test';
import CompModal from '@/components/CompModal';
import CompLoading from '@/components/CompLoading';
import SOCIAL from '@/constants/social';
import { loadFbSdk } from '@/utils/social';

export default {
  name: 'mc6',
  mixins: [common],
  data() {
    return {
      tab: 'home',
      headerPos: 'on-top',
      headerLeftIcon: 'fa-bars',
      headerRightIcon: this.$route.params.id ? '' : 'fa-share-alt',
      headerRightSubIcon: 'fa-bell',
      headerPageTitle: 'TEAManity',
      showModal: false,

      docHeight: window.innerHeight,
      docWidth: window.innerWidth,

      myType: '',
      friends: [],

      myProfileImage: '',
      info: false,
      infoText: this.$i18n.t('mc6.info'),
      id: '',
      copyModal: false,
      copyModalMsg: '',
      goTestModal: false,
      friendsModal: false,
      friendsModalBody: '',

      needsRefresh: false,
      unreadNotiFlag: '',
      isLoading: false,
    };
  },
  components: {
    CompHeader,
    CompProfile,
    CompBottomTab,
    CompShare,
    CompModal,
    CompLoading,
  },
  computed: {
    setPos() {
      const docHeight = this.docHeight;
      const docWidth = this.docWidth;
      let marginValue = '';
      if (docHeight > docWidth) {
        const marginCal = (docHeight - docWidth) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-left': marginValue,
          width: 'auto',
          height: '100%',
        };
      }
      if (docHeight < docWidth) {
        const marginCal = (docWidth - docHeight) / 2;
        marginValue = `-${marginCal}px`;
        return {
          'margin-top': marginValue,
          width: '100%',
          height: 'auto',
        };
      }
      return {
        width: '100%',
        height: 'auto',
      };
    },
  },
  methods: {
    showMenu() {
      this.isShowMenu(true);
    },
    handleResize() {
      this.docHeight = window.innerHeight;
      this.docWidth = window.innerWidth;
    },
    share() {
      if (!this.$route.params.id) {
        this.showModal = true;
      }
    },
    showNotification() {
      this.goPage('/notification');
    },
    getMC6(userId) {
      this.isLoading = true;
      this.friendsModal = false;

      this.friends = [];
      this.updateMagicCircle({ data: this.friends }, userId);

      if (this.$route.params.id || userId) {
        this.getShareMC6(this.$route.params.id || userId);
      } else {
        this.$store.dispatch('getMc6').then(({ data, status }) => {
          if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
            this.$store.dispatch('refreshToken').then((response) => {
              if (response.status === RESPONSE.SUCCESS.CODE) {
                this.getMC6();
              } else {
                this.invalidateLogin();
              }
            });
          } else {
            this.myProfileImage = this.$store.getters.getProfileImage;
            this.setMC6(data);
          }
        });
      }
    },
    getShareMC6(id) {
      localStorage.setItem('shareUserSeqId', id);
      this.$store.dispatch('getShareMc6', { id }).then((response) => {
        if (response.data.photoUrl) {
          this.myProfileImage = response.data.photoUrl;
        }
        this.setMC6(response.data, id);
      });
    },
    setMC6(data, userId) {
      const qCnt = this.$store.getters.getQCnt;

      if (qCnt < TEST.MAXIMUM && (!this.$route.params.id || !userId)) {
        this.infoText = this.$i18n.t('mc6.info');
        this.info = true;
      } else if (this.$route.params.id || userId) {
        this.infoText = `${data.nickname}님의 MC6입니다.`;
        this.info = true;
      } else {
        this.infoText = this.$i18n.t('mc6.info');
        this.info = false;
      }

      this.updateMagicCircle(data, userId);

      // eslint-disable-next-line
      if (qCnt == TEST.MAXIMUM) {
        this.chkFriendsAvailable();
      }
      this.isLoading = false;
    },
    updateMagicCircle(data, userId) {
      if (Object.prototype.hasOwnProperty.call(data, 'friends')) {
        this.friends = data.friends;
      }
      if (Object.prototype.hasOwnProperty.call(data, 'typeName')) {
        this.myType = data.typeName;
      }

      this.friends.forEach((friend) => {
        const that = this;
        if (friend.userSeqId > 0) {
          if (!this.$route.params.id || !userId) {
            friend.click = () => {
              that.$router.push({
                path: `/match/result/${friend.userSeqId}`,
                query: {
                  username: friend.nickname,
                  type: friend.typeCode,
                },
              });
            };
          } else {
            friend.click = () => {};
          }
        } else {
          friend.nickname = '?';
          if (this.$route.params.id || userId) {
            friend.click = () => {};
          } else {
            friend.click = () => {
              that.showModal = true;
            };
          }
        }

        if (friend.typeOrder === 2) {
          friend.position = 'top';
        } else if (friend.typeOrder === 3) {
          friend.position = 'right';
        } else if (friend.typeOrder === 4) {
          friend.position = 'bottom-right';
        } else if (friend.typeOrder === 5) {
          friend.position = 'bottom-left';
        } else {
          friend.position = 'left';
        }
      });
    },
    chkFriendsAvailable() {
      this.needsRefresh = false;
      const friendSeqId = localStorage.getItem('shareUserSeqId');
      if (friendSeqId) {
        localStorage.removeItem('shareUserSeqId');
        // eslint-disable-next-line
        if (this.$store.getters.getUserSeqId != friendSeqId) {
          this.$store
            .dispatch('addFriend', { friendSeqId })
            .then(({ status, error }) => {
              if (status === 500) {
                this.friendsModalBody = this.$i18n.t('error.notEnoughQuest');
                this.friendsModal = true;
              } else if (status === 400 && error.resultCode === -200) {
                this.friendsModalBody = error.resultMsg;
                this.friendsModal = true;
              } else if (status === 400 && error.resultCode === -300) {
                this.friendsModalBody = error.resultMsg;
                this.friendsModal = true;
              } else {
                this.friendsModalBody = this.$i18n.t('mc6.friends.done');
                this.friendsModal = true;
                this.needsRefresh = true;
              }
            });
        }
      }
    },
    detectTPBrowser() {
      const uAgent = navigator.userAgent.toLowerCase();
      if (uAgent.indexOf('samsungbrowser') > -1) {
        return true;
      } else if (uAgent.indexOf('firefox') > -1) {
        return true;
      }
      return false;
    },
    fbShare(url) {
      const isTPBrowser = this.detectTPBrowser();
      if (isTPBrowser) {
        this.copyModalMsg = this.$i18n.t('error.trackingProtection');
        this.copyModal = true;
      } else {
        try {
          // eslint-disable-next-line
          FB.ui(
            {
              method: 'share',
              href: url,
              hashtag: '#TEAManity',
              // eslint-disable-next-line
            },
            // eslint-disable-next-line no-unused-vars
            (response) => {
              this.showModal = false;
            },
          );
        } catch (exception) {
          if (exception instanceof ReferenceError) {
            loadFbSdk(
              SOCIAL.FACEBOOK_APP_ID,
              SOCIAL.FACEBOOK_API_VERSION,
            ).then(() => this.fbShare(url));
          }
        }
      }
    },
    urlShare(text) {
      this.textCopy(text);
      this.showModal = false;
      this.copyModalMsg = this.$i18n.t('friends.urlCopy');
      this.copyModal = true;
    },
    checkCntBeforeGo(path) {
      let qCnt = this.$store.getters.getQCnt;
      if (qCnt) {
        this.goReport(qCnt, path);
      } else {
        this.$store.dispatch('getQuestion').then((result) => {
          if (result.data.data.qanum) {
            qCnt = result.data.data.qanum;
          } else if (result.error.resultCode === RESPONSE.NO_QUESTION.CODE) {
            qCnt = TEST.MAXIMUM;
          }

          if (qCnt) {
            this.$store.dispatch('setQCnt', { qCnt }).then(() => {
              this.goReport(qCnt, path);
            });
          }
        });
      }
    },
    goReport(qCnt, path) {
      if (this.$route.params.id) {
        return;
      }
      if (qCnt < TEST.MAXIMUM) {
        this.goTestModal = true;
      } else {
        this.goPage(path);
      }
    },
    goTest() {
      this.goTestModal = false;
      this.isShowMenu(false);
      this.goPage('/test/question');
    },
    checkNotificationCount() {
      this.$store.dispatch('getUnreadNotiCount').then(({ data, status }) => {
        if (status === RESPONSE.TOKEN_EXPIRED.CODE) {
          this.$store.dispatch('refreshToken').then((response) => {
            if (response.status === RESPONSE.SUCCESS.CODE) {
              this.checkNotificationCount();
            } else {
              this.invalidateLogin();
            }
          });
        } else if (data.countOfunReadAlarms === '0') {
          this.unreadNotiFlag = '';
        } else {
          this.unreadNotiFlag = 'sub';
        }
      });
    },
    getProfileImage() {
      return this.$store.getters.getProfileImage;
    },
    addFriendsDone() {
      this.friendsModal = false;
      this.$route.push('/mc6');
    },
  },
  created() {
    const storeJobList = this.$store.getters.getJobs;
    if (!storeJobList || storeJobList.length === 0) {
      this.$store.dispatch('getJobs');
    }
    this.getMC6();
    this.checkNotificationCount();
  },
  beforeMount() {
    this.$store.dispatch('clearTmpUserEmail').then();
    this.$store.dispatch('clearTmpUserPassword').then();
    this.$store.dispatch('clearTmpUserNickname').then();
    this.$store.dispatch('clearTmpUserName').then();
    this.$store.dispatch('clearTmpUserBirth').then();
    this.$store.dispatch('clearTmpUserEducation').then();
    this.$store.dispatch('clearTmpTagList').then();
    this.$store.commit('clearTagList');
    this.$store.dispatch('clearTmpClientId').then();

    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  metaInfo() {
    return {
      title: this.$i18n.t('share.title'),
      meta: [
        {
          vmid: 'og:title',
          property: 'og:title',
          content: 'title',
        },
        {
          vmid: 'og:url',
          property: 'og:url',
          content: `https://api.teamanity.app:11604/mc6/${this.id}`,
        },
        {
          vmid: 'og:image',
          property: 'og:image',
          content: this.$i18n.t('share.imgUrl'),
        },
        {
          vmid: 'og:description',
          property: 'og:description',
          content: this.$i18n.t('share.desc'),
        },
      ],
    };
  },
};
</script>

<style lang="scss" src="../../scss/mc6.scss" scoped></style>



// WEBPACK FOOTER //
// src/views/mc6/mc6-intro.vue